"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _styles = require("@material-ui/core/styles");

var _Avatar2 = _interopRequireDefault(require("./Avatar.css"));

var _utils = require("../../utils");

var Avatar =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Avatar, _React$PureComponent);

  function Avatar() {
    (0, _classCallCheck2.default)(this, Avatar);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Avatar).apply(this, arguments));
  }

  (0, _createClass2.default)(Avatar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alt = _this$props.alt,
          classes = _this$props.classes,
          light = _this$props.light,
          onError = _this$props.onError,
          src = _this$props.src;
      return React.createElement(_Avatar.default, {
        alt: alt,
        src: src,
        imgProps: {
          onError: onError
        },
        classes: {
          root: classes.root,
          colorDefault: (0, _clsx.default)(classes.colorDefault, light && 'light')
        },
        children: this.transformedChildren
      });
    }
  }, {
    key: "transformedChildren",
    get: function get() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          classes = _this$props2.classes;
      var transformed = (0, _utils.isTextContent)(children) ? (0, _utils.transformName)(children) : children;
      return React.createElement("span", {
        className: classes.avatarTextOffset
      }, transformed);
    }
  }]);
  return Avatar;
}(React.PureComponent);

Avatar.defaultProps = {
  alt: '',
  classes: {},
  light: false,
  size: '3x',
  style: {}
};
Avatar.propTypes = {
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: PropTypes.string,

  /**
   * Used to render icon or text elements inside the Avatar.
   * `src` and `alt` props will not be used and no `img` will
   * be rendered by default.
   *
   * This can be an element, or just a string.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,

  /**
   * The color of the avatar.
   */
  color: PropTypes.string,

  /**
   * Whether the Avatar is in light mode or not.
   * Defaults to false.
   */
  light: PropTypes.bool,

  /**
   * A function that is called when there is an error in loading the Avatar image.
   */
  onError: PropTypes.func,

  /**
   * The width and height of the avatar.
   */
  size: PropTypes.oneOf(['1x', '2x', '3x', '4x', 24, 30, 32, 36]),

  /**
   * The `src` attribute for the `img` element.
   */
  src: PropTypes.string
};

var _default = (0, _styles.withStyles)(_Avatar2.default)(Avatar);

exports.default = _default;